import stylesBreakpoint from 'common/styles/styles.breakpoint';
import { themedStyled } from 'common/styles/styletron.theme';

export const SectionContainer = themedStyled('div', {
  flex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  gap: '24px',
  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    flexDirection: 'column',
  },
});

export const BetweenContainer = themedStyled('div', {
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'flex-start',
});

export const DifferenceDaysContainer = themedStyled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    width: '100%',
  },
});

export const RightButtonContainer = themedStyled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '4px',
  whiteSpace: 'nowrap',
  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    marginTop: '0px',
    marginBottom: '24px',
  },
}));

export const InputContainer = themedStyled('div', ({ $theme }) => ({
  marginBottom: '16px',
  [`@media screen and (max-width: calc(${stylesBreakpoint.lg} - 1px))`]: {
    marginBottom: '6px',
  },
}));
